import { gsap } from "gsap";

const ContactOverlay = () => {
  const navigateToContact = () => {
    gsap.to(window, {
      scrollTo: ".contact",
      duration: 1.5,
      ease: "Power4.easeInOut",
    });
  };

  return (
    <div className="contact-overlay" onClick={navigateToContact}>
      <img src="/images/circ_text.png" alt="" />
      <img
        src="/images/avatar.png"
        alt=""
        className="contact-overlay__avatar"
      />
    </div>
  );
};

export default ContactOverlay;
